export default function renderPolicyName(policyType: string, displayName?: string): string {
  if (displayName) {
    return `${displayName} - ${policyType}`;
  }
  return policyType;
}
